'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = request;
/* eslint-env browser */

function request() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments[1];

  var xhr = new XMLHttpRequest();

  xhr.addEventListener('progress', cb);
  xhr.addEventListener('load', cb);
  xhr.addEventListener('error', cb);
  xhr.addEventListener('abort', cb);

  xhr.ontimeout = function () {
    var ev = {
      type: 'timeout',
      currentTarget: xhr
    };

    cb(ev);
  };

  xhr.open(options.method, options.baseUrl + options.url);

  xhr.timeout = options.timeout || 0;

  options.onRequest(xhr, options);

  return xhr;
}
//# sourceMappingURL=request.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/http/lib/request.js
// module id = 931
// module chunks = 5